var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "options-group card-text group" },
    [
      _vm.isCollapsible
        ? _c(
            "div",
            {
              class: _vm.headerClasses,
              on: {
                click: function ($event) {
                  _vm.isCollapsed = !_vm.isCollapsed
                },
              },
            },
            [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.config.label) + "\n        "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCollapsed
        ? _vm._l(_vm.config.options, function (option, key) {
            return _c(
              "div",
              { key: key },
              [
                option.heading && !option.hidden
                  ? _c("h5", { staticClass: "option-heading" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(option.heading) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !option.hidden
                  ? _c(option.type, {
                      tag: "component",
                      class: _vm.componentClasses,
                      attrs: { value: _vm.value[key], config: option },
                      on: {
                        input: function ($event) {
                          return _vm.update(key, $event)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }